interface PermissionDotsProps {
  groupColours: Array<any>;
  tooltipClassName: string;
  dotClassName?: string;
}

const PermissionDots = ({
  groupColours,
  tooltipClassName,
  dotClassName = 'w-3 h-3 rounded-full group/groups cursor-pointer transition-all relative',
}: PermissionDotsProps) => (
  <>
    {groupColours.map((item) => (
      <div
        key={`group-colour-${item.ID}`}
        className={dotClassName}
        style={{ backgroundColor: item.colour }}
      >
        <p className={tooltipClassName}>{item.name}</p>
      </div>
    ))}
  </>
);

export default PermissionDots;
